export default "__VITE_ASSET__NvExZNXa__"